import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

// If you have a shared initialized firebaseApp instance, ensure it's imported or available.
// Firebase's getFunctions() will naturally hook into the default initialized app.
const functions = getFunctions(undefined, 'us-central1');

export default function TickerTest() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    setError(null);
    setResults([]);

    try {
      // 1. Target our freshly deployed v2 onCall function by its string name
      const searchTickersApi = httpsCallable(functions, 'searchTickers');
      
      // 2. Invoke it. Firebase client SDK automatically constructs the headers,
      // handles session tokens, and maps the payload under {"data": { query }}
      const response = await searchTickersApi({ query: query.trim() });
      
      // 3. Unpack the results returned from the Polygon API mapping
      if (response.data && response.data.results) {
        setResults(response.data.results);
      } else if (response.data && response.data.error) {
        setError(response.data.error);
      }
    } catch (err) {
      console.error("Round-trip execution failed:", err);
      setError(err.message || "An unexpected runtime error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', backgroundColor: '#1e1e1e', color: '#fff', borderRadius: '8px' }}>
      <h3 style={{ marginTop: 0, color: '#4F46E5' }}>⚡️ Live v2 Ticker Search Verification</h3>
      <p style={{ fontSize: '14px', color: '#aaa' }}>Tests the secure serverless bridge to Polygon API via Cloud Run.</p>
      
      <form onSubmit={handleSearch} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="e.g. AAPL, TSLA, MSFT"
          style={{
            flex: 1,
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #444',
            backgroundColor: '#2a2a2a',
            color: '#fff'
          }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            padding: '10px 20px',
            backgroundColor: loading ? '#444' : '#4F46E5',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontWeight: 'bold'
          }}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </form>

      {error && (
        <div style={{ color: '#EF4444', padding: '10px', backgroundColor: '#3B1414', borderRadius: '4px', marginBottom: '20px' }}>
          ❌ Error: {error}
        </div>
      )}

      <div>
        <h4>Results ({results.length})</h4>
        {results.length === 0 && !loading && !error && <p style={{ color: '#666', fontSize: '14px' }}>No tickers loaded yet. Type a query above.</p>}
        
        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
          {results.map((ticker) => (
            <li key={ticker.ticker} style={{
              padding: '12px',
              borderBottom: '1px solid #333',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div>
                <strong style={{ color: '#10B981', marginRight: '10px' }}>{ticker.ticker}</strong>
                <span style={{ color: '#ddd', fontSize: '14px' }}>{ticker.name}</span>
              </div>
              <small style={{ color: '#666', backgroundColor: '#111', padding: '2px 6px', borderRadius: '4px' }}>
                {ticker.market} / {ticker.locale}
              </small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}